import React, {useEffect}  from "react"; 
import { Link } from 'react-router-dom'; 
import Header from '../Component/Header'
import Footer from '../Component/Footer' 

const MandatoryDisclosure = () => { 
    useEffect(() => {
        document.title = 'Mandatory Disclosure - Jai Rani Public School, Balussery';  
    }, []);   
    return (
        <>
            <Header />
<div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>   
                    <li>Mandatory Disclosure</li>
                </ul>
            </div> 
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1>Mandatory Disclosure</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                        
                           <button className="cbsesaras">
                              <a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/CBSESARAS.pdf" target="_blank"> CBSE SARAS</a>
                           </button>                        
                              <button className="cbsesaras">
                              <a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/CBSESARAS-Land-Correction.pdf" target="_blank"> CBSE SARAS Land Correction</a>
                           </button> 
                        <h6>GENERAL INFORMATION</h6>
                        <div className="table-responsive maintable">
                            <table className="table">
                                <thead>
                                   <tr><th width="2%;">S.No.</th><th>INFORMATION</th><th>DETAILS</th></tr>
                               </thead>
                               <tbody>
                        <tr><td>1</td>
                         <td>NAME OF THE SCHOOL </td>
                         <td>Jai Rani SABS Public School</td>
                         </tr>
                    <tr><td>2</td>
                     <td>AFFILIATION NO.(IF APPLICABLE)</td>
                     <td> 930962 </td>
                     </tr>
                    <tr><td>3</td>
                     <td>SCHOOL CODE (IF APPLICABLE)</td>
                     <td>76021</td>
                     </tr>
                    <tr><td>4</td>
                     <td>COMPLETE ADDRESS WITH PIN CODE</td>
                     <td>BALUSSERY (PO)KOYILANDY KOZHIKODE,   KOZHIKODE , KERALA - 673612</td>
                     </tr>
                    <tr><td>5</td>
                     <td>PRINCIPAL NAME   </td>
                     <td>ANUSHA MATHEW  </td>
                     </tr>
                     <tr><td>6</td>
                     <td>PRINCIPAL  QUALIFICATION: </td>
                     <td> 
M.A. B. Ed.</td>
                     </tr>
                    <tr><td>7</td>
                     <td>SCHOOL EMAIL ID </td>
                     <td>jrnsabs@gmail.com</td>
                     </tr>
                    <tr><td>8</td>
                     <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                     <td>9539985678</td>
                     </tr></tbody></table></div><h6>DOCUMENTS AND INFROMATION</h6><div className="table-responsive maintable"><table className="table"><thead>
                        <tr><th width="2%;">S.No.</th><th>DOCUMENTS/INFORMATION</th><th>VIEW</th></tr></thead><tbody>
                        <tr><td>1</td>
                         <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY </td>
                         <td><a className="a1" href="https://webapi.entab.info/api/image/JRPSB/public/pdf/Affliation.pdf" target="_blank"> VIEW </a></td>
                         </tr>
                    <tr><td>2</td>
                     <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/TRUSTCERTIFICATE.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>3</td>
                     <td>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/NOC.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>4</td>
                     <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S RENEWAL IF APPLICABLE</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/RECOGNITIONCERTIFICATE.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>5</td>
                     <td>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/BUILDINGSAFETYCERTIFICATE.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>6</td>
                     <td>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/FIRESAFETYCERTIFICATE.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>7</td>
                     <td> COPY OF THE SELF CERTIFICATIONSUBMITTED BY THE SCHOOL FORAFFILIATION/UPGRADATION/EXTENSIONOF AFFILIATION</td>
                      <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/selfcertification.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    
                    <tr><td>8</td>
                     <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
                      <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/WATERCERTIFICATE.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>9</td>
                     <td> TRANSPORT FITNESS CERTIFICATE </td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/Transport-Fitness-Certificate.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>10</td>
                     <td>NON-PROPRIETARY AFFIDAVIT</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/NON-PROPRIETARY-AFFIDAVIT.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>11</td>
                     <td>TEACHER'S DETAILS</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/Teacher-Details.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>12</td>
                     <td>TEXT BOOKS LIST</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/Text-Books.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                     <tr><td>13</td>
                     <td>Class wise students strength</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/studentsstrength.pdf" target="_blank"> VIEW </a></td>
                     </tr>
          <tr><td>14</td>
                     <td>COPIES OF LAND CERTIFICATES</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/LAND-CERTIFICATES.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                   { /*  <tr><td>10</td>
                     <td>NORMS FOR FIXING FEE</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/FIXING-FEE.pdf" target="_blank"> VIEW </a></td>
                     </tr> */
    }
                     
                     </tbody></table></div><h6>DOCUMENTS AND INFROMATION</h6><div className="table-responsive maintable"><table className="table"><thead>
                        <tr><th width="2%;">S.No.</th><th>DOCUMENTS/INFORMATION</th><th>VIEW</th></tr></thead><tbody>
                        <tr><td>1</td>
                         <td>FEE STRUCTURE OF THE SCHOOL</td>
                          <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/Fee-structure.pdf" target="_blank"> VIEW </a></td>
                         </tr>
                    <tr><td>2</td>
                     <td>ANNUAL ACADEMIC CALANDER.</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/ANNUALACADEMIC.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>3</td>
                     <td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td>
                     <td><a className="a1" href="https://webapi.entab.info/api/image/JRPSB/public/pdf/SMC.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>4</td>
                     <td>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/PTA.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                    <tr><td>4</td>
                     <td>LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABLILITY</td>
                     <td><a href="https://webapi.entab.info/api/image/JRPSB/public/pdf/threeRESULT.pdf" target="_blank"> VIEW </a></td>
                     </tr>
                 { /*   <tr><td>5</td>
                     <td>SELF DECLARATION</td>
                     <td><a href="#" target="_blank"> VIEW </a></td>
                     </tr> */ }
                    
                     </tbody></table></div><h6>RESULT CLASS XII</h6><div className="table-responsive maintable"><table className="table"><thead>
                        <tr><th width="2%;">S.No.</th><th>YEAR</th><th>NO. OF REGISTERED STUDENTS</th><th>NO. OF STUDENTS PASSED</th><th>PASS PERCENTAGE</th></tr></thead><tbody>
                        <tr><td>1</td>
                         <td>2025</td>
                         <td>30</td>
                         <td>30</td>
                         <td>100 %</td>
                         </tr>
                    { /*  <tr><td>2</td>
                     <td>2023</td>
                     <td>29</td>
                     <td>29</td>
                     <td>100 %</td>
                     </tr>
                    <tr><td>3</td>
                     <td>2022</td>
                     <td>35</td>
                     <td>35</td>
                     <td>100 %</td>
                     </tr> */}
                    </tbody></table></div><h6>STAFF (TEACHING)</h6><div className="table-responsive maintable"><table className="table"><thead>
                        <tr><th width="2%;">S.No.</th><th>INFORMATION</th><th>DETAILS</th></tr></thead><tbody>
                        <tr><td>1</td>
                         <td>PRINCIPAL</td>
                         <td>1</td>
                         </tr><tr rowspan="6"><td>2 </td>
                         <td>TOTAL NO. OF TEACHERS</td>
                         <td> 49</td>
                         </tr>
                         <tr><td> </td>
                         <td> PET  </td>
                         <td>2</td>
                         </tr>
                    <tr><td> </td>
                     <td>TGT </td>
                     <td>17</td>
                     </tr>
                    <tr><td> </td>
                     <td>PRT  </td>
                     <td>23</td>
                     </tr>
                    
                    
                    
                    <tr><td>3</td>
                     <td>TEACHERS SECTION RATIO</td>
                     <td>1:1.5</td>
                     </tr>
                    <tr><td>4</td>
                     <td>DETAILS OF SPECIAL EDUCATOR</td>
                     <td>JINCY THOMAS</td>
                     </tr>
                    <tr><td>5</td>
                     <td>DETAILS OF COUNSELLOR AND WELNESS TEACHER</td>
                     <td>REGEENA CHACKO</td>
                     </tr>
                    </tbody>
                    </table>
                    </div>
                    <h6>SCHOOL INFRASTRUCTURE</h6>
                    <div className="table-responsive maintable">
                        <table className="table">
                            <thead>
                        <tr><th width="2%;">S.No.</th><th>INFORMATION</th><th>DETAILS</th></tr>
                    </thead>
                    <tbody>
                        <tr><td>1</td>
                         <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</td>
                         <td> 9144</td>
                         </tr>
                    <tr><td>2 </td>
                     <td>NO. AND SIZE OF THE CLASS ROOMS (IN SQ FTMTR)</td>
                     <td>35 & 34</td>
                     </tr>
                    <tr><td>3</td>
                     <td>NO. AND SIZE OF LABORATORIES INCLUDING  COMPUTER  LABS (IN SQ MTR)</td>
                     <td>2 & 87</td>
                     </tr>
                    <tr><td>4</td>
                     <td>INTERNET FACILITY (Y/N)</td>
                     <td>YES</td>
                     </tr>
                    <tr><td>5</td>
                     <td>NO. OF GIRLS TOILETS</td>
                     <td>25</td>
                     </tr>
                    <tr><td>6</td>
                     <td>NO. OF BOYS TOILETS</td>
                     <td>21</td>
                     </tr>
                    <tr><td>7</td>
                     <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
                     <td><a className="a1" href="https://youtu.be/DCQCPV0kh0Q" target="_blank"> YOUTUBE </a></td>
                     </tr>
                    </tbody>
                    </table>
                    </div>
                    </div>
                        </div>
                    </div> 
                </div> 
             <Footer />
        </>
    );
}

export default MandatoryDisclosure;
